import ABTestsActionTypes from './ABTestsActionTypes';
import { type IAction } from '../../types/commonTypes';
import ABTestsReducerInitialState from './ABTestsReducerInitialState';

export const ABTestsReducer = (state = ABTestsReducerInitialState, action: IAction): string[] => {
  switch (action.type) {
    case ABTestsActionTypes.ADD_ACTIVE_TESTS:
      return {
        ...state
      };

    default:
      return state;
  }
};

export default ABTestsReducer;
